<div class=" o-modal--medium" id="mod-ap-req" style="width: 100%;">
    <div class="o-modal__head" >
        <a class="o-modal__close close-modal" matDialogClose></a>
        <label class="o-title o-title--white o-title--medium">{{'SaaDelegateModalConfirmPortal.title'|translate}}</label>
    </div>
    
        <mat-dialog-content style="width:100%;" >
            <div style="padding-left: 40px; margin-top: 30px; margin-bottom: 30px;">
                <p>{{'SaaDelegateModalConfirmPortal.body1'|translate}}.</p>
                <p>{{'SaaDelegateModalConfirmPortal.body2'|translate}}. </p>
            </div>
        </mat-dialog-content>
        <div class="o-modal__footer">
            <div>
                <button mat-button mat-dialog-close (click)="Close()" class="btn btn--default " style="color:black" ><u>{{'SaaDelegateModalConfirmPortal.back'|translate}}</u></button>
               <button mat-button (click)="Accept()" class="btn btn--primary" >{{'SaaDelegateModalConfirmPortal.delegateAcept'|translate}}</button>
           </div> 
       </div>
</div>